import { Component, ViewChild } from '@angular/core';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { DepartmentsService } from './departments.service';
import { IDepartmentsUpdatePayload } from './departments.interface';
import { EditDepartmentComponent } from './edit-department/edit-department.component';
import { AddDepartmentComponent } from './add-department/add-department.component';

@Component({
    selector: 'app-departments-settings',
    templateUrl: './departments-settings.component.html',
    styleUrls: ['./departments-settings.component.scss'],
})
export class DepartmentsSettingsComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;

    isLoading = false;
    showCard = false;
    activeValue: string = '-1';

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink =
        environment.interop.basePath +
        environment.interop.platform.nomenclatoare.department.getDepartmentsDT;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '0' },
        { key: 'Nu', value: '1' },
    ];

    onSelectionChange(event: any): void {
        this.activeValue = event.value;
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private departmentsService: DepartmentsService
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            responsive: true,
            pageLength: 25,

            ajax: (dataTablesParameters: any, callback: any) => {
                dataTablesParameters.param1 = this.activeValue;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id_department',
                },
                {
                    title: 'Denumire',
                    data: 'name',
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    className: 'all',
                    orderable: false,
                    render: () => {
                        return `
            <div class="d-flex align-center justify-content-left">
              <button class="action-btn edit ms-1">
                <img class="btn-img" src="/assets/icons/edit.svg" alt="edit"/>
              </button>
              <button class="action-btn delete ms-1">
                <img class="btn-img" src="/assets/icons/delete.svg" alt="delete"/>
              </button>
              </div>
            `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd ?.querySelector('.edit');
                const deleteIcon = lastTd ?.querySelector('.delete');

                if (editIcon) {
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    deleteIcon.addEventListener('click', () => {
                        const { id_department } = data;
                        this.deleteDepartment(id_department);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next('');
        });
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddDepartmentComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.rerenderDT();
            }
        });
    }

    openEditDialog(data: IDepartmentsUpdatePayload) {
        const dialogRef = this.dialog.open(EditDepartmentComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.rerenderDT();
            }
        });
    }

    deleteDepartment(departmentId: number) {
        Swal.fire({
            title: 'Sunteți sigur?',
            text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Confirm!',
            cancelButtonText: 'Cancel',
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.departmentsService
                    .deleteDepartament(departmentId)
                    .subscribe(() => {
                        this.rerenderDT();
                        Swal.fire({
                            title: 'Șters!',
                            text: 'Departament șters cu succes.',
                            icon: 'success',
                            confirmButtonText: 'OK',
                        });
                    });
            }
        });
    }
}
